import React from 'react'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import {Font, fontStyles, useLoadFont} from 'lib/FontSelect'
import {BaseTemplate} from 'Event/template'

export default function PostFormSubmitButton(props: {
  postFormStyles: BaseTemplate['postFormStyles'] | undefined
  children: React.ReactNode
  disabled?: boolean
  className?: string
  type?: 'submit' | 'button'
  onClick?: () => void
  'aria-label'?: string
}) {
  const {postFormStyles: styles, children, ...buttonProps} = props
  const font = styles?.buttonFont ?? null

  useLoadFont(font)

  return (
    <StyledButton
      type={buttonProps.type || 'submit'}
      variant="outlined"
      disabled={buttonProps.disabled}
      className={buttonProps.className}
      onClick={buttonProps.onClick}
      aria-label={buttonProps['aria-label']}
      color={styles?.buttonColor}
      backgroundColor={styles?.buttonBackgroundColor}
      backgroundHoverColor={styles?.buttonHoverBackgroundColor}
      hoverTextColor={styles?.buttonHoverTextColor}
      radius={styles?.buttonRadius}
      width={styles?.buttonSize}
      borderWidth={styles?.buttonBorderWidth}
      borderColor={styles?.buttonBorderColor}
      hoverBorderColor={styles?.buttonHoverBorderColor}
      fontSize={styles?.buttonFontSize}
      minHeight={styles?.buttonHeight}
      disableHover={styles?.buttonDisableHover}
      buttonFont={font}
    >
      {children}
    </StyledButton>
  )
}

const StyledButton = styled(
  ({
    color: _1,
    backgroundColor: _2,
    backgroundHoverColor: _3,
    hoverTextColor: _4,
    radius: _5,
    fontSize: _6,
    width: _7,
    borderWidth: _8,
    borderColor: _9,
    hoverBorderColor: _10,
    minHeight: _11,
    disableHover: _12,
    buttonFont: _13,
    ...otherProps
  }) => <Button {...otherProps} />,
)<{
  color?: string
  backgroundColor?: string
  backgroundHoverColor?: string
  hoverTextColor?: string | null
  radius?: number
  width?: number
  borderWidth?: number
  borderColor?: string
  hoverBorderColor?: string | null
  fontSize?: number
  minHeight?: number | null
  disableHover?: boolean
  buttonFont?: Font | null
}>`
  color: ${(props) => props.color} !important;
  cursor: pointer;
  font-size: ${(props) => props.fontSize}px !important;
  border-radius: ${(props) => props.radius}px !important;
  background: ${(props) => props.backgroundColor} !important;
  width: ${(props) => props.width}% !important;
  border-width: ${(props) => props.borderWidth}px !important;
  border-color: ${(props) => props.borderColor} !important;
  border-style: solid !important;
  font-family: inherit !important;
  ${(props) =>
    props.minHeight != null
      ? `min-height: ${props.minHeight}px !important;`
      : ''}
  ${(props) => fontStyles(props.buttonFont ?? null)}

  &:hover {
    background: ${(props) =>
      props.disableHover
        ? props.backgroundColor
        : props.backgroundHoverColor} !important;
    ${(props) =>
      props.hoverTextColor ? `color: ${props.hoverTextColor} !important;` : ''}
    ${(props) =>
      props.hoverBorderColor
        ? `border-color: ${props.hoverBorderColor} !important;`
        : ''}
  }
`
